import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs';
import termData from '../../../constants/introductionTerms.json'
import './Term.css'

class Term extends Component {
    render() {
        var data, content, options, backBtn;
        if (this.props.match.params.id == null) {
            data = termData[0];
        }
        else {
            data = termData.filter(term => term.name == this.props.match.params.id)[0];
            backBtn = <Link to="/introduction/term">Back</Link>
        }
        if (data == null) {
            data = termData[0];
        }
        content = data.content.map(con => {
            return <p className="pcontent" key={con}>{con}</p>
        });
        options = data.options.map(opt => {
            var link = "";
            if (opt.type == "1") {
                link = <Link to={opt.path}>{opt.name}</Link>
            }
            else {
                link = <a href={process.env.BASE_URL + opt.path} download >{opt.name}</a>
            }
            return (<li key={opt.name}>
                {link}
            </li>
            )
        });

        return (
                <div className="introduction-main">
                    <Breadcrumbs />
                    <div className="introduction-content">
                    <p className="introduction-heading">
                        {data.header}
                    </p>
                    {content}
                    <ul>
                        {options}
                    </ul><br/><br/>
                    {backBtn}
                    </div>
                </div>
        )
    }

}

Term.propTypes = {
    match: PropTypes.object,
    params: PropTypes.object,
    id: PropTypes.string
}

export default Term;